import { createTypographyBundlesMap } from './utils/createTypographyBundlesMap/createTypographyBundlesMap'

export const typographyBundles = createTypographyBundlesMap()
